import { createFileRoute } from '@tanstack/react-router'
import { resolveLegacyPreferencesPath } from '@/lib/legacy-routes'
import { redirectFromLegacyPath, splitSplat } from '@/lib/legacy-redirect'

/** Every `/preferences/…` URL the old app could produce. */
export const Route = createFileRoute('/preferences/$')({
  loader: ({ context: { queryClient }, params }) =>
    redirectFromLegacyPath(queryClient, resolveLegacyPreferencesPath(splitSplat(params._splat))),
})
